import React from 'react'
import { Spinner } from 'reactstrap'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import ApiService from '../services/ApiService'
import { format } from 'date-fns'
import { connect } from 'react-redux'
import { useQuery } from "@tanstack/react-query";

const TicketsSold = ({ date, tenant }) => {
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }
  const { data, isLoading, isRefetching, isSuccess } = useQuery({
    queryKey: ["getSoldTickets", tenant.id, since, until],
    queryFn: () => ApiService.getSoldTickets(since, until),
    select: (data) => data.data,
    placeholderData: {
      data: [],
    },
  });

  const chartOptions = () => {
    return {
      credits: { enabled: false },
      chart: {
        type: "column",
      },
      title: {
        text: "",
      },
      yAxis: {
        title: {
          text: data.yTitle,
        },
        labels: {
          style: {
            color: 'var(--text-primary)'
          }
        },
      },
      xAxis: {
        categories: data.labels,
        labels: {
          rotation: -45,
          style: {
            color: 'var(--text-primary)'
          }
        },
        title: {
          text: data.xTitle,
        },
      },
      series: data.series,
      plotOptions: {
        column: {
          stacking: "normal",
          borderColor: null,

        },
      },
    };
  };

  return (
    <>
      {(isLoading || isRefetching) && <Spinner color="primary" />}
      {isSuccess && (
        <HighchartsReact highcharts={Highcharts} options={chartOptions()} />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  date: state.date,
  tenant: state.auth.tenant,
});

export default connect(mapStateToProps)(TicketsSold);
